import { Link } from "react-router-dom";

export default function DataRoom() {
  return (
    <section>
      <div className="wrap">
        <div className="gate">
          <div className="eyebrow">Investor data room</div>
          <h1>Request access.</h1>
          <p className="sub center">
            The data room contains fund documentation, audited financials, regulatory filings,
            and recent transaction memos. Access is restricted to professional and
            institutional investors.
          </p>
          <a
            className="btn btn-primary spacer-m"
            href="mailto:info@daksfirst.com?subject=Data%20room%20access%20request"
          >
            Request access via email
          </a>
          <ul className="reqs spacer-l">
            <li>You will be asked to confirm professional / institutional investor status</li>
            <li>NDA execution before access is granted</li>
            <li>Per-fund documentation: PPM, AIFM details, audited accounts, depositary letter</li>
            <li>Recent transaction memos and pipeline (under NDA only)</li>
          </ul>
          <p className="small spacer-m">
            Access is granted on our <Link to="/data-room-terms" style={{ color: "var(--gold)" }}>data room terms</Link> to
            relevant persons as defined in our <Link to="/investor-access" style={{ color: "var(--gold)" }}>Investor access statement</Link>.
          </p>
        </div>
      </div>
    </section>
  );
}
